import axios from 'axios';
import queryString from 'query-string';

export const getFiles = search => axios.get(`/files/list/?${queryString.stringify(search)}`);

export const getFile = id => axios.get(`/files/${id}/`);

const multipartConfig = { headers: { 'Content-Type': 'multipart/form-data' } };

export const createFile = body => axios.post('/files/create/', body, multipartConfig);

export const uploadFile = (title, file) => {
  const data = new FormData();
  data.append('title', title);
  data.append('file', file);
  return axios.post(`/files/create/`, data, multipartConfig);
};

export const editFile = (id, body) => axios.put(`/files/${id}/`, body, multipartConfig);

export const deleteFile = id => axios.delete(`/files/${id}/`);

export const getFileExtensions = () => axios.get('/files/extensions/');

/**
 * Create a PlatformFileType with an associated ManagedPlatformFile.
 * This is used to create user-specific file entries (e.g., signed agreement PDFs).
 *
 * @param {Object} params - Parameters for creating the platform file type
 * @param {string|number} params.file_id - The ID of the BrokerFile to associate
 * @param {string} params.title - Title for the platform file type
 * @param {string} params.description - Description for the file
 * @param {string|number} params.logo_id - The ID of the logo BrokerFile (default: 1)
 * @param {string} params.os_type - OS type (default: "All")
 * @returns {Promise} Axios promise
 */
export const createPlatformFileType = params => {
  const data = new FormData();
  data.append('file_id', params.file_id);
  data.append('title', params.title);
  data.append('description', params.description || '');
  data.append('logo_id', params.logo_id || 1);
  data.append('os_type', params.os_type || 'All');
  return axios.post('/files/create_platform_file_type/', data, multipartConfig);
};
